/* ============================================
   Artemis Theme — Predictive Search
   ============================================ */

(function () {
  'use strict';

  var searchContainer = document.getElementById('predictive-search');
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  var searchToggle = document.querySelector('.header__search-toggle');
  var searchStatus = document.querySelector('[data-predictive-search-status]');
  var closeButtons = document.querySelectorAll('[data-predictive-search-close]');

  if (!searchContainer || !searchInput || !searchResults) return;

  var debounceTimer;
  var activeIndex = -1;

  function getOptions() {
    return searchResults.querySelectorAll('[role="option"]');
  }

  function setStatus(message) {
    if (searchStatus) searchStatus.textContent = message;
  }

  function setExpanded(expanded) {
    searchInput.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function clearActiveOption() {
    var options = getOptions();
    for (var i = 0; i < options.length; i++) {
      options[i].classList.remove('is-active');
      options[i].removeAttribute('aria-selected');
    }
    activeIndex = -1;
    searchInput.setAttribute('aria-activedescendant', '');
  }

  function setActiveOption(index) {
    var options = getOptions();
    if (options.length === 0) return;

    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;

    for (var i = 0; i < options.length; i++) {
      options[i].classList.remove('is-active');
      options[i].removeAttribute('aria-selected');
    }

    var active = options[index];
    active.classList.add('is-active');
    active.setAttribute('aria-selected', 'true');
    activeIndex = index;
    searchInput.setAttribute('aria-activedescendant', active.id);

    if (typeof active.scrollIntoView === 'function') {
      active.scrollIntoView({ block: 'nearest' });
    }
  }

  function getFocusable() {
    return searchContainer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function openSearch() {
    searchContainer.hidden = false;
    document.body.style.overflow = 'hidden';
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { searchInput.focus(); }, 100);
  }

  function closeSearch() {
    searchContainer.hidden = true;
    document.body.style.overflow = '';
    searchInput.value = '';
    searchResults.innerHTML = '';
    clearActiveOption();
    setExpanded(false);
    setStatus('');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    if (searchToggle) searchToggle.focus();
  }

  function performSearch(query) {
    if (query.length < 2) {
      searchResults.innerHTML = '';
      clearActiveOption();
      setExpanded(false);
      setStatus('');
      return;
    }

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        renderResults(data.resources.results, query);
      })
      .catch(function () {
        searchResults.innerHTML = '<p class="predictive-search__no-results">Search unavailable</p>';
        clearActiveOption();
        setExpanded(true);
        setStatus('Search unavailable');
      });
  }

  function renderResults(results, query) {
    var html = '';
    var products = results.products || [];
    var articles = results.articles || [];
    var pages = results.pages || [];
    var allResults = products.concat(articles, pages);
    var optionIndex = 0;

    if (allResults.length === 0) {
      html = '<p class="predictive-search__no-results">No results found</p>';
    } else {
      products.forEach(function (product) {
        var imageHtml = '';
        if (product.image) {
          imageHtml = '<div class="predictive-search__item-image"><img src="' + product.image + '" alt="" loading="lazy"></div>';
        }
        html += '<a href="' + product.url + '" class="predictive-search__item" id="predictive-option-' + optionIndex + '" role="option">' +
          imageHtml +
          '<div class="predictive-search__item-info">' +
            '<p class="predictive-search__item-title">' + product.title + '</p>' +
            '<p class="predictive-search__item-price">' + product.price + '</p>' +
          '</div>' +
        '</a>';
        optionIndex++;
      });

      articles.forEach(function (article) {
        html += '<a href="' + article.url + '" class="predictive-search__item" id="predictive-option-' + optionIndex + '" role="option">' +
          '<div class="predictive-search__item-info">' +
            '<p class="predictive-search__item-title">' + article.title + '</p>' +
            '<p class="predictive-search__item-price">Article</p>' +
          '</div>' +
        '</a>';
        optionIndex++;
      });

      pages.forEach(function (page) {
        html += '<a href="' + page.url + '" class="predictive-search__item" id="predictive-option-' + optionIndex + '" role="option">' +
          '<div class="predictive-search__item-info">' +
            '<p class="predictive-search__item-title">' + page.title + '</p>' +
            '<p class="predictive-search__item-price">Page</p>' +
          '</div>' +
        '</a>';
        optionIndex++;
      });

      html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all" id="predictive-option-' + optionIndex + '" role="option">View all results</a>';
      optionIndex++;
    }

    searchResults.innerHTML = html;
    clearActiveOption();
    setExpanded(true);

    if (allResults.length === 0) {
      setStatus('No results found');
    } else {
      setStatus(allResults.length + (allResults.length === 1 ? ' result found' : ' results found'));
    }
  }

  // Event listeners
  if (searchToggle) {
    searchToggle.addEventListener('click', openSearch);
  }

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (e) {
    if (searchContainer.hidden) return;

    if (e.key === 'Escape') {
      closeSearch();
      return;
    }

    // Focus trap: cycle Tab within the open search container.
    if (e.key === 'Tab') {
      var focusable = getFocusable();
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Combobox keyboard navigation on the input.
  searchInput.addEventListener('keydown', function (e) {
    var options = getOptions();

    if (e.key === 'ArrowDown') {
      if (options.length === 0) return;
      e.preventDefault();
      setActiveOption(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      if (options.length === 0) return;
      e.preventDefault();
      setActiveOption(activeIndex - 1);
    } else if (e.key === 'Enter') {
      if (activeIndex > -1 && options[activeIndex]) {
        var href = options[activeIndex].getAttribute('href');
        if (href) {
          e.preventDefault();
          window.location.href = href;
        }
      }
    }
  });

  searchInput.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var query = searchInput.value.trim();
    debounceTimer = setTimeout(function () {
      performSearch(query);
    }, 300);
  });
})();
